"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUsersVidyardStatus = getUsersVidyardStatus;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URI = 'filemanager/api/v3/portal-meta';

function getUsersVidyardStatus(userId) {
  return _apiClient.default.get(BASE_URI, {
    query: {
      userId: userId
    }
  });
}